import { useTranslation } from '@packlink/translation-provider';
import {
    getButtonStyles,
    getContainerStyles,
    getEditIconStyles,
    getTitleWrapperStyles,
    getTagStyles,
    getDescriptionStyles,
} from './EmailTemplateListItemStyles';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    Icon,
    IconSize,
    Tag,
    TagColor,
    TagVariant,
    Typography,
} from '@shipengine/giger';

import { IconNames } from '@shipengine/giger-theme';

export interface EmailTemplateListItemProps {
    onPreview: () => void;
}

export function EmailTemplateDefaultItem({ onPreview }: EmailTemplateListItemProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <div css={getContainerStyles}>
            <section css={getDescriptionStyles}>
                <div css={getTitleWrapperStyles}>
                    <div>
                        <Typography variant="heading5" bold>
                            {t(`branded-emails.template-list.default-title`)}
                        </Typography>

                        <Tag
                            variant={TagVariant.LINEAL_FILLED}
                            color={TagColor.SUCCESS}
                            uppercase={false}
                            css={getTagStyles}
                        >
                            {t('branded-emails.template-list.active-email')}
                        </Tag>
                    </div>
                </div>
                <Typography variant="body2">{t(`branded-emails.template-list.default-description`)}</Typography>
            </section>
            <section>
                <Button
                    variant={ButtonVariant.OUTLINED}
                    onClick={onPreview}
                    css={getButtonStyles}
                    size={ButtonSize.SMALL}
                >
                    <Icon name={IconNames.EYE} size={IconSize.SIZE_SMALL} css={getEditIconStyles} />
                    {t('branded-emails.template-list.cta-preview')}
                </Button>
            </section>
        </div>
    );
}
